// extracted by mini-css-extract-plugin
export default {"Fotter":"Fotter_Fotter__1k9f9","contact":"Fotter_contact__tteOO","data":"Fotter_data__bKB8o"};